/**
 * Lệnh Bot — Rename TKQC navigation config.
 */

export const RENAME_TKQC_ROUTE_NAME = 'LenhBotRenameTkqc'
export const RENAME_TKQC_ITEM_ID    = 'lenh-bot-rename-tkqc'
export const RENAME_TKQC_LABEL      = 'Rename TKQC'
export const RENAME_TKQC_TITLE      = 'Lệnh Bot · Rename TKQC'
